import React, { Component } from 'react';
import Navigation from '../components/Navigation';
import PageSnippetsTable from '../components/PageSnippetsTable';
import { translate } from 'react-i18next';
import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    Form,
    DropdownButton,
    MenuItem
} from 'react-bootstrap';
import HeaderFooterPanel from '../components/HeaderFooterPanel';
import config from '../config';
import qs from 'qs';
import reorder from '../helpers/reorder';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';

import './Page.css';

class Page extends Component {
    constructor(props) {
        super(props);
        const { uuid } = this.props.match.params;

        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            page: null,
            uuid,
            lockedGlobals: false,
            snippets: [],
            selectedSnippets: new Set(),
            selectedSnippetsData: new Map(),
            selectAllMode: false,
            selectAllPages: false,
            totalSnippets: 0,
            excludedSnippets: new Set(),
            excludedSnippetsData: new Map()
        };
    }

    componentDidMount() {
        this.loadPageFromServer();
        this.loadPageSnippetsFromServer();
    }

    deleteSnippet(snippet) {
        const { uuid, pageUUID } = this.props.match.params;

        var self = this;
        axios
            .delete(
                `${config.baseURL}/pages/${pageUUID}/snippets/${snippet.uuid}`
            )
            .then(function(response) {
                self.loadPageSnippetsFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadPageSnippetsFromServer() {
        const { uuid, pageUUID } = this.props.match.params;

        var self = this;
        axios
            .get(`${config.baseURL}/pages/${pageUUID}/snippets`, {})
            .then(function(response) {
                self.setState({
                    snippets: response.data.snippets,
                    totalSnippets: response.data.snippets.length
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadPageFromServer() {
        const { uuid, pageUUID } = this.props.match.params;

        var self = this;
        axios
            .get(`${config.baseURL}/pages/${pageUUID}`, {})
            .then(function(response) {
                self.setState({ page: response.data.page });
                self.loadPlayerFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadPlayerFromServer() {
        var self = this;
        const { playerUUID } = this.props.match.params;

        axios
            .get(`${config.baseURL}/players/${playerUUID}`, {})
            .then(function(response) {
                self.setState({
                    player_name: response.data.player.name
                });
                self.loadOrganisationInformation();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name,
                    lockedGlobals: response.data.organisation.lockedGlobals
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    reorderSnippets(result) {
        const { pageUUID } = this.props.match.params;

        const reorderedSnippets = reorder(
            this.state.snippets,
            result.source.index,
            result.destination.index
        );
        this.setState({
            snippets: reorderedSnippets
        });
        const ordering = {};
        for (var i = 0; i < reorderedSnippets.length; i++) {
            const snippet = reorderedSnippets[i];
            ordering[snippet.uuid] = i;
        }

        try {
            var self = this;
            axios
                .post(`${config.baseURL}/pages/${pageUUID}/snippets/reorder `, {
                    ordering
                })
                .then(function(response) {
                    console.log('Success!');
                })
                .catch(function(err) {
                    console.log(err);
                });
        } catch (e) {
            console.log('exception');
        }
    }

    handleSelect(eventKey, event) {
        console.log(`Chose: ${eventKey}`);
        const { uuid, playerUUID, pageUUID } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;

        if (eventKey === 'new') {
            let createLink = `/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/snippets/create?rel=player`;
            if (rel === 'page') {
                createLink = `/organisations/${uuid}/pages/${pageUUID}/snippets/create?rel=page`;
            }

            this.props.history.push(createLink);
        } else if (eventKey === 'existing') {
            let addLink = `/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/snippets/add?rel=player`;
            if (rel === 'page') {
                addLink = `/organisations/${uuid}/pages/${pageUUID}/snippets/add?rel=page`;
            }

            this.props.history.push(addLink);
        }
    }

    handleSelectSnippet = (snippetUuid, isSelected) => {
        let selectedSnippets = new Set(this.state.selectedSnippets);
        let selectedSnippetsData = new Map(this.state.selectedSnippetsData);
        let excludedSnippets = new Set(this.state.excludedSnippets);
        let excludedSnippetsData = new Map(this.state.excludedSnippetsData);

        if (isSelected) {
            if (this.state.selectAllMode) {
                excludedSnippets.delete(snippetUuid);
                excludedSnippetsData.delete(snippetUuid);
            } else {
                selectedSnippets.add(snippetUuid);
                const snippetData = this.state.snippets.find(s => s.uuid === snippetUuid);
                if (snippetData) {
                    selectedSnippetsData.set(snippetUuid, snippetData);
                }
            }
        } else {
            if (this.state.selectAllMode) {
                excludedSnippets.add(snippetUuid);
                const snippetData = this.state.snippets.find(s => s.uuid === snippetUuid);
                if (snippetData) {
                    excludedSnippetsData.set(snippetUuid, snippetData);
                }
            } else {
                selectedSnippets.delete(snippetUuid);
                selectedSnippetsData.delete(snippetUuid);
            }
        }

        this.setState({
            selectedSnippets,
            selectedSnippetsData,
            excludedSnippets,
            excludedSnippetsData
        });
    };

    handleSelectAll = (isSelectAll) => {
        if (isSelectAll) {
            // Select all items on current page only
            const currentPageSnippetUuids = new Set(this.state.snippets.map(s => s.uuid));
            const currentPageSnippetsData = new Map(this.state.snippets.map(s => [s.uuid, s]));

            this.setState({
                selectAllMode: false,  // Keep false - only for current page
                selectAllPages: false,
                selectedSnippets: currentPageSnippetUuids,
                selectedSnippetsData: currentPageSnippetsData,
                excludedSnippets: new Set(),
                excludedSnippetsData: new Map()
            });
        } else {
            this.setState({
                selectAllMode: false,
                selectAllPages: false,
                selectedSnippets: new Set(),
                selectedSnippetsData: new Map(),
                excludedSnippets: new Set(),
                excludedSnippetsData: new Map()
            });
        }
    };

    handleSelectAllPages = () => {
        this.setState({
            selectAllMode: true,  // NOW set to true
            selectAllPages: true,
            selectedSnippets: new Set(),
            selectedSnippetsData: new Map()
        });
    };

    showBulkDeleteConfirmation = () => {
        const { t } = this.props;

        let bodyContent;

        if (this.state.selectAllPages) {
            const effectiveCount = this.state.totalSnippets - this.state.excludedSnippets.size;
            bodyContent = (
                <div>
                    <p><strong>Warning: This will delete all {effectiveCount} snippets from this page!</strong></p>
                    <p>This includes all snippets
                    {this.state.excludedSnippets.size > 0 && <span>, excluding {this.state.excludedSnippets.size} manually deselected items</span>}.</p>
                    <p><em>This action cannot be undone.</em></p>
                </div>
            );
        } else {
            const selectedItems = Array.from(this.state.selectedSnippetsData.values());
            bodyContent = (
                <div>
                    <p><strong>This will delete {selectedItems.length} selected snippet{selectedItems.length === 1 ? '' : 's'}:</strong></p>
                    <ul style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                        {selectedItems.map(item => (
                            <li key={item.uuid}><strong>{item.name}</strong> ({item.type})</li>
                        ))}
                    </ul>
                </div>
            );
        }

        this.dialog.show({
            title: t('Dialog.warning'),
            body: bodyContent,
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => this.dialog.hide(),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.confirmBulkDelete(),
                    'btn-danger'
                )
            ],
            bsSize: 'large'
        });
    };

    handleBulkDelete = () => {
        this.showBulkDeleteConfirmation();
    };

    confirmBulkDelete = () => {
        const { pageUUID } = this.props.match.params;

        const usingSelectAll = this.state.selectedSnippets.size > 0 || this.state.selectAllPages;

        const payload = {
            selectAll: usingSelectAll,
            selectAllPages: this.state.selectAllPages,
            snippets: this.state.selectAllPages ? [] : Array.from(this.state.selectedSnippets),
            excludedSnippets: this.state.selectAllPages ? Array.from(this.state.excludedSnippets) : []
        };

        console.log('🔍 BULK DELETE PAYLOAD:', {
            selectAll: payload.selectAll,
            selectAllPages: payload.selectAllPages,
            itemsCount: payload.snippets ? payload.snippets.length : 0,
            items: payload.snippets,
            excludedItemsCount: payload.excludedSnippets.length,
            state: {
                selectedItemsSize: this.state.selectedSnippets ? this.state.selectedSnippets.size : 0,
                selectAllPages: this.state.selectAllPages,
                totalItems: this.state.totalSnippets
            }
        });

        axios
            .post(`${config.baseURL}/pages/${pageUUID}/snippets/bulk-delete`, payload)
            .then((response) => {
                this.setState({
                    selectedSnippets: new Set(),
                    selectedSnippetsData: new Map(),
                    excludedSnippets: new Set(),
                    excludedSnippetsData: new Map(),
                    selectAllMode: false,
                    selectAllPages: false
                }, () => {
                    this.loadPageSnippetsFromServer();
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };

    render() {
        const { t } = this.props;
        const { uuid, playerUUID, pageUUID } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;
        document.title = `MySign Digital Screen Solutions | ${t('Page.title')}`;

        const superAdmin = this.state.userIsAuthorized(this.state.user, ['staff_super_admin']);
        const shouldHideGlobalButton = this.state.lockedGlobals && !superAdmin;

        const selectedCount = this.state.selectAllPages
            ? this.state.totalSnippets - this.state.excludedSnippets.size
            : this.state.selectedSnippets.size;
        const hasSelection = selectedCount > 0;

        const allCurrentPageSelected = this.state.selectedSnippets.size === this.state.snippets.length && this.state.snippets.length > 0;
        const showSelectAllPagesBanner = allCurrentPageSelected && !this.state.selectAllPages && this.state.totalSnippets > this.state.snippets.length;

        return (
            <div className="Page">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('Page.title')}{' '}
                                    <small>
                                        {this.state.player_name}{' '}
                                        <small style={{ whiteSpace: 'nowrap' }}>
                                            {this.state.organisation_name}
                                        </small>
                                    </small>
                                    {this.state.userIsAuthorized(
                                        this.state.user,
                                        [
                                            'staff_super_admin',
                                            'staff_admin',
                                            'organisation_admin',
                                            'organisation_user'
                                        ]
                                    ) ? (
                                        <DropdownButton
                                            bsStyle={'primary'}
                                            title={
                                                <span>
                                                    <em className="fa fa-plus fa-fw" />{' '}
                                                    {t('Page.add_snippet')}
                                                </span>
                                            }
                                            onSelect={this.handleSelect.bind(
                                                this
                                            )}
                                        >
                                            <MenuItem eventKey="new">
                                                {t('Page.create_new')}
                                            </MenuItem>
                                            
                                            {/* <MenuItem eventKey="existing">
                                                {t('Page.choose_existing')}
                                            </MenuItem> */}

                                             {!shouldHideGlobalButton ? 
                                                <MenuItem
                                                    eventKey="existing"
                                                   
                                                >
                                                     {t('Page.choose_existing')}
                                                </MenuItem>
                                            :<></>}
                                        </DropdownButton>
                                    ) : null}
                                    {rel === 'player' ? (
                                        <>
                                        <a
                                            id="previewButton"
                                            type="submit"
                                            className="btn btn-success header-button"
                                            target="_blank"
                                            href={`${
                                                config.playersBaseURL
                                            }/mediaserver/unit.php?playerUUID=${playerUUID}&preview=1`}
                                        >
                                            <em className="fa fa-eye fa-fw" />{' '}
                                            {t('Player.preview_player')}
                                        </a>

                                        <a
                                            id="previewButton"
                                            type="submit"
                                            className="btn btn-warning header-button"
                                            target="_blank"
                                            href={`${
                                                config.playersBaseURL
                                            }/mediaserver/unit.php?playerUUID=${playerUUID}&preview=1&ignoreRules=1`}
                                        >
                                            <em className="fa fa-eye fa-fw" />{' '}
                                            {t('Player.preview_player_all')}
                                        </a>

                                        </>
                                    ) : null}
                                </h1>
                                <ol className="breadcrumb">
                                    {rel === 'player' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players`}
                                                >
                                                    {t(
                                                        'SideNavigation.players'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}`}
                                                >
                                                    {t(
                                                        'OrganisationPlayer.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages`}
                                                >
                                                    {t('SideNavigation.pages')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fa fa-puzzle-piece" />{' '}
                                                {t('Page.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}
                                    {rel === 'page' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${
                                                        this.state.uuid
                                                    }`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${
                                                        this.state.uuid
                                                    }/pages`}
                                                >
                                                    {t(
                                                        'SideNavigation.globalpages'
                                                    )}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fa fa-puzzle-piece" />{' '}
                                                {t('Page.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}
                                </ol>

                                <HeaderFooterPanel
                                    title={'Snippets'}
                                    headerContent={
                                        hasSelection && this.state.userIsAuthorized(this.state.user, ['staff_super_admin', 'staff_admin', 'organisation_admin']) ? (
                                            <div style={{ marginLeft: '20px', display: 'inline-flex', gap: '10px', alignItems: 'center' }}>
                                                <span style={{ color: '#31708f', fontWeight: 'normal', fontSize: '14px' }}>
                                                    <strong>{selectedCount}</strong> snippet{selectedCount === 1 ? '' : 's'} selected
                                                    {this.state.selectAllPages && <span> (all)</span>}
                                                    {showSelectAllPagesBanner && (
                                                        <span>
                                                            {' '}
                                                            <a
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.handleSelectAllPages();
                                                                }}
                                                                style={{ textDecoration: 'underline', color: '#31708f', fontWeight: 'bold' }}
                                                            >
                                                                Select all {this.state.totalSnippets} snippets?
                                                            </a>
                                                        </span>
                                                    )}
                                                </span>
                                                <Button
                                                    className="btn-default btn-sm"
                                                    onClick={() => {
                                                        this.setState({
                                                            selectedSnippets: new Set(),
                                                            selectedSnippetsData: new Map(),
                                                            excludedSnippets: new Set(),
                                                            excludedSnippetsData: new Map(),
                                                            selectAllMode: false,
                                                            selectAllPages: false
                                                        });
                                                    }}
                                                    style={{ fontSize: '12px' }}
                                                >
                                                    <em className='far fa-square' /> Select None
                                                </Button>
                                                <Button
                                                    className="btn-danger btn-sm"
                                                    onClick={this.handleBulkDelete}
                                                    style={{ fontSize: '12px' }}
                                                >
                                                    <em className="fa fa-trash" /> Delete Selected
                                                </Button>
                                            </div>
                                        ) : null
                                    }
                                >
                                    <PageSnippetsTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        snippets={this.state.snippets}
                                        uuid={uuid}
                                        playerUUID={playerUUID}
                                        pageUUID={pageUUID}
                                        rel={rel}
                                        onDelete={this.deleteSnippet.bind(this)}
                                        onDragEnd={this.reorderSnippets.bind(
                                            this
                                        )}
                                        onSelectSnippet={this.handleSelectSnippet}
                                        onSelectAll={this.handleSelectAll}
                                        selectedSnippets={this.state.selectedSnippets}
                                        excludedSnippets={this.state.excludedSnippets}
                                        selectAllMode={this.state.selectAllMode}
                                    />
                                </HeaderFooterPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(Page);
